let bodyScrollLock: any
if (typeof window !== 'undefined') {
  bodyScrollLock = require('body-scroll-lock')
}
import * as React from 'react'
import IFrame from 'react-iframe'
import Button from '../button/button'
import Modal from '../modal/modal'
import Subscription from '../subscription.js/subscription'
import './block-subscription.scss'

class BlockSubscription extends React.Component<{}, {}> {
  constructor() {
    super()
  }

  public render() {
    return (
      <div className="block-subscription">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="subscription">
                <h2 className="subscription__heading">
                  Try Bizy now. It’s free.
                </h2>
                <Subscription />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BlockSubscription



// WEBPACK FOOTER //
// ./src/components/block-subscription/block-subscription.tsx